import React from 'react';
import PropTypes from 'prop-types';
import cname from './style.module.scss';
import {PipetteBody} from './PipetteBody';
import {PipettePlunger} from './PipettePlunger';

export function PipetteImage(props) {
  return (
    <div className={`${cname.pipette} ${props.className}`}>
      <PipettePlunger className={`${cname.plunger} pipette-plunger`} type={props.type} />
      <PipetteBody
        className={`${cname.body} pipette-body`}
        type={props.type}
        solution={props.solution}
        hasTip={props.hasTip}
      />
    </div>
  );
}

PipetteImage.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * Type of MicroPipette
   */
  type: PipetteBody.propTypes.type,
};

PipetteImage.defaultProps = {
  type: PipetteBody.defaultProps.type,
};
